<!-- eCharts Component -->
<div echarts [options]="echartOptions"></div>
